import React, { useState } from 'react';
import Button from '../UI/Button';
import Input from '../UI/Input';
import UserMenu from '../User/UserMenu';
import CurrencyRates from './CurrencyRates';
import AdminArea from '../../pages/Admin/AdminArea';
import Modal from '../UI/Modal';
import DeveloperNameAnimated from './DeveloperNameAnimated';
import './Header.css';

const DEVELOPER_EMAIL = 'onderxyilmaz@gmail.com';

const Header = ({
  searchTerm,
  onSearchChange,
  percentageValue,
  onPercentageChange,
  onPercentageIncrease,
  onPercentageDecrease,
  onBulkEdit,
  onBulkStock,
  selectedCount,
  percentageLoading,
  products = [],
  catalogView = 'all',
  onCatalogViewChange,
  activeCollection = null,
  onBackToCollections,
  collectionCount = 0,
  activeVendor = null,
  onBackToVendors,
  vendorCount = 0
}) => {
  const [showAdminArea, setShowAdminArea] = useState(false);
  const [showDeveloperModal, setShowDeveloperModal] = useState(false);

  const searchIcon = (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m21 21-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
  );

  return (
    <>
      <div className="header-container">
        <div className="header-content">
          <div className="header-title-row">
            <h1 className="header-title">
              <span className="title-icon">🛍️</span>
              {catalogView === 'collection' && activeCollection
                ? activeCollection.title
                : catalogView === 'vendor' && activeVendor
                  ? activeVendor.title
                  : catalogView === 'collections'
                    ? 'Koleksiyonlar'
                    : catalogView === 'vendors'
                      ? 'Satıcılar'
                      : 'Shopify Ürün Yönetimi'}
              <span className="product-count">
                {catalogView === 'collections'
                  ? `(${collectionCount} koleksiyon)`
                  : catalogView === 'vendors'
                    ? `(${vendorCount} satıcı)`
                    : `(${products.length} ürün${selectedCount > 0 ? `, ${selectedCount} seçildi` : ''})`}
              </span>
            </h1>

            <div className="header-title-right">
              <CurrencyRates />

              <div
                className="header-developer-box"
                role="button"
                tabIndex={0}
                aria-label="Geliştirici bilgisini aç"
                title="Geliştirici bilgisini göster"
                onClick={() => setShowDeveloperModal(true)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setShowDeveloperModal(true);
                  }
                }}
              >
                <p className="header-developer-info">
                  Developed by <span className="header-developer-name">Önder Yılmaz</span>
                </p>
              </div>
            </div>
          </div>

          <div className="catalog-nav">
            <div className="catalog-toggle" role="tablist" aria-label="Katalog görünümü">
              <button
                type="button"
                role="tab"
                aria-selected={catalogView === 'all'}
                className={`catalog-toggle-btn ${catalogView === 'all' ? 'active' : ''}`}
                onClick={() => onCatalogViewChange?.('all')}
              >
                Tüm ürünler
              </button>
              <button
                type="button"
                role="tab"
                aria-selected={catalogView === 'collections' || catalogView === 'collection'}
                className={`catalog-toggle-btn ${catalogView === 'collections' || catalogView === 'collection' ? 'active' : ''}`}
                onClick={() => onCatalogViewChange?.('collections')}
              >
                Koleksiyonlar
              </button>
              <button
                type="button"
                role="tab"
                aria-selected={catalogView === 'vendors' || catalogView === 'vendor'}
                className={`catalog-toggle-btn ${catalogView === 'vendors' || catalogView === 'vendor' ? 'active' : ''}`}
                onClick={() => onCatalogViewChange?.('vendors')}
              >
                Satıcılar
              </button>
            </div>
            {catalogView === 'collection' && (
              <button
                type="button"
                className="catalog-back-btn"
                onClick={onBackToCollections}
              >
                ← Koleksiyonlar
              </button>
            )}
            {catalogView === 'vendor' && (
              <button
                type="button"
                className="catalog-back-btn"
                onClick={onBackToVendors}
              >
                ← Satıcılar
              </button>
            )}
          </div>

          {/* Main Controls - Alt satır */}
          <div className="header-controls">
            {catalogView !== 'collections' && catalogView !== 'vendors' && (
            <div className="percentage-controls">
              <Input
                type="number"
                value={percentageValue}
                onChange={(e) => onPercentageChange(e.target.value)}
                placeholder="Yüzde değeri"
                size="md"
                className="percentage-input"
                autoComplete="off"
              />
              <Button
                variant="success"
                size="md"
                onClick={onPercentageIncrease}
                disabled={percentageLoading !== null || selectedCount === 0}
                loading={percentageLoading === 'increase'}
              >
                % Artır
              </Button>
              <Button
                variant="danger"
                size="md"
                onClick={onPercentageDecrease}
                disabled={percentageLoading !== null || selectedCount === 0}
                loading={percentageLoading === 'decrease'}
              >
                % Azalt
              </Button>
            </div>
            )}

            <div className="search-container">
              <Input
                type="search"
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                placeholder={
                  catalogView === 'collections'
                    ? 'Koleksiyon adı ile ara...'
                    : catalogView === 'vendors'
                      ? 'Satıcı adı ile ara...'
                      : 'Ürün adı ile ara...'
                }
                icon={searchIcon}
                size="md"
                className="search-input"
                autoFocus
                autoComplete="off"
              />
            </div>

            {catalogView !== 'collections' && catalogView !== 'vendors' && (
            <div className="bulk-action-buttons">
              <Button
                variant="warning"
                size="md"
                onClick={onBulkEdit}
                disabled={selectedCount === 0}
                className="bulk-edit-btn"
              >
                Toplu Fiyat {selectedCount > 0 && `(${selectedCount})`}
              </Button>
              <Button
                variant="success"
                size="md"
                onClick={onBulkStock}
                disabled={selectedCount === 0}
                className="bulk-stock-btn"
              >
                Toplu Stok {selectedCount > 0 && `(${selectedCount})`}
              </Button>
            </div>
            )}

            {/* User Menu */}
            <UserMenu onAdminAreaClick={() => setShowAdminArea(true)} />
          </div>
        </div>
      </div>

      {/* Admin Area Modal */}
      <AdminArea
        isOpen={showAdminArea}
        onClose={() => setShowAdminArea(false)}
      />

      <Modal
        isOpen={showDeveloperModal}
        onClose={() => setShowDeveloperModal(false)}
        title="Geliştirici"
        size="md"
      >
        <div className="developer-about-modal">
          <DeveloperNameAnimated />
          <div className="developer-about-mail-row">
            <a
              href={`mailto:${DEVELOPER_EMAIL}`}
              className="developer-about-email"
            >
              <span className="developer-about-email-icon" aria-hidden>
                <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </span>
              <span>{DEVELOPER_EMAIL}</span>
            </a>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Header;
